export default "__VITE_ASSET__BHyoueHA__"